import reject from "ramda/src/reject";
import isEmpty from "ramda/src/isEmpty";

export const rejectIsEmpty = reject(isEmpty);
